enum PaymentMethod {
  WireTransfer = 'WireTransfer',
  DirectDebit = 'DirectDebit',
}

export default PaymentMethod;
